export default class TranscriptFiltersViewModel {
    transcriptMode: string = 'Non-Transcript Search';
    transcriptOptions: string = '';
    searchMode: string = '';
    searchValues: string = '';
}